import React, { Component } from 'react';
import { Steps } from 'intro.js-react';
import { Trans } from 'react-i18next';
import i18next from 'i18next';
import store from 'store';
import actions from 'store/actions';
import StoreGetters from 'store/store-getters';
import {
  STATE,
  SynchronizeController,
} from 'services/3dviewer/moving-controls/synchronizeController';
import {
  createObjectManager,
  ObjectManagers,
} from 'services/3dviewer/object-manager';

import ThreeScene from './threeScene';
import StyleSelectBoard from './styleSelectBoard';
import StyleSelectionMobile from './styleSelectionMobile';
import StyleSelection from './styleSelection';
import SelectionList from './selectionList';
import ToolBar from './toolbar';
import ToolBarMobile from './toolbarMobile';
import QRCodeBoard from './QRCodeBoard';
import ViewChangeMenu from './viewChangeMenu';
import RoomTag from './roomtag';
import Ruler from './ruler';
import VerifySection from './verifySection';
import FunctionBarMobile from './functionBarMobile';

import { VIEW } from './config';
import { navigationBridge } from 'services/postMessage/navigationBridge';
import loading from 'asset/image/multiStyleLoading.gif';
import 'intro.js/introjs.css';
import './css/index.scss';
import titleDropdown from 'asset/image/titleDropdown.svg';

const waitTime = 500; // 0.5s
var removeCU2 = false; // [Note]: Remove CU2 flag

export default class Viewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewLoadCompleted: false,
      styleLoadCompleted: true,
      view: VIEW.SINGLE, //初始View模式
      openQRCodeBoard: false,
      RWD: 'PC',
      isNotFirst: false,
      openTitleMenu: false,
      stepsEnabled: false,
      initialStep: 0,
      steps: [],
    };

    this.toggleMenu = this.toggleMenu.bind(this);
    this.rulerStatus = false;
    this.cameraHeight = 160;
    this.isMultiStyle = false;
    this.maxStyleNum = 0; // [Note]: 多樓層多風格不足防呆
    console.log('version : 20220831/1345f4fc');
  }

  async loadData(callback) {
    const { building } = store.getState();

    Object.keys(building.floorList[0].labels).map((labelid, index) => {
      if (index == 0) {
        this.cameraHeight =
          building.floorList[0].labels[labelid].cameraHeight * 100;
      }
    });

    const Mapping = {};
    ObjectManagers.length = 0;

    await this.getMaxStyleNum(building); // [Note]: 多樓層多風格不足防呆
    for (let index in building.floorList) {
      try {
        const {
          dollHouseCubemapsData,
          hierarchy,
          labels,
          doorModelData,
          roomModelData,
          id,
        } = building.floorList[index];
        // [Note]: Remove CU2 flag: used for ruler calculation
        const removeCU2Flag = building.floorList[index].data.removeCU2;
        removeCU2 = removeCU2Flag;

        let floorID = id;
        if (hierarchy) Mapping[floorID] = {}; // [bug]: 多樓層站點無法移動
        for (let i = 0; i < this.maxStyleNum; i++) {
          // [Note]: 多樓層多風格不足防呆
          Mapping[floorID][i] = createObjectManager();
          const ObjectManager = ObjectManagers[Mapping[floorID][i]];

          // [Note]: 多樓層多風格不足防呆
          let panoramas;
          if (i < hierarchy.length) {
            panoramas = hierarchy[i].panoramas;
          } else {
            panoramas = hierarchy[0].panoramas;
          }
          SynchronizeController.setSceneInfo(
            await ObjectManager.init(
              panoramas,
              roomModelData,
              doorModelData,
              labels,
              dollHouseCubemapsData,
              removeCU2Flag // [Note]: Remove CU2 flag
            ),
            Mapping
          );
        }
      } catch (e) {
        continue;
      }
    }

    callback();
  }

  getMaxStyleNum = building => {
    for (let index in building.floorList) {
      const { hierarchy } = building.floorList[index];
      if (hierarchy.length > this.maxStyleNum) {
        this.maxStyleNum = hierarchy.length;
      }
    }
    // [Note]: at least "2" for creating left scene and right scene
    if (this.maxStyleNum < 2) this.maxStyleNum = 2;
  };

  setSteps = styles => {
    if (styles.length > 1) {
      this.isMultiStyle = true;
      this.setState({
        steps: [
          {
            element: '.dollhouse-btn',
            title: `${i18next.t(
              'viewMode.dollhouse'
            )}<div>(<span>1</span>/7)</div>`,
            intro: i18next.t('tutorial.step1'),
          },
          {
            element: '.dollhouse-tutorial',
            title: `${i18next.t(
              'tutorial.hotspot'
            )}<div>(<span>2</span>/7)</div>`,
            intro: i18next.t('tutorial.step2'),
            position: 'left',
          },
          {
            element: '.birdview-btn',
            title: `${i18next.t(
              'viewMode.birdView'
            )}<div>(<span>3</span>/7)</div>`,
            intro: i18next.t('tutorial.step3'),
          },
          {
            element: '.fpview-button',
            title: `${i18next.t('tutorial.back')}<div>(<span>4</span>/7)</div>`,
            intro: i18next.t('tutorial.step4'),
          },
          {
            element: '.svg-ruler',
            title: `${i18next.t(
              'tutorial.ruler'
            )}<div>(<span>5</span>/7)</div>`,
            intro: i18next.t('tutorial.step5'),
            position: 'left',
          },
          {
            element: '.select-style-board-close-1',
            title: `${i18next.t(
              'action.multiStyle'
            )}<div>(<span>6</span>/7)</div>`,
            intro: i18next.t('tutorial.step6'),
            position: 'left',
          },
          {
            element: '.select-style-board-div',
            title: `${i18next.t(
              'action.multiStyle'
            )}<div>(<span>7</span>/7)</div>`,
            intro: i18next.t('tutorial.step7'),
            position: 'right',
          },
        ],
      });
    } else {
      this.changeView(VIEW.SINGLE);
      this.setState({
        steps: [
          {
            element: '.dollhouse-btn',
            title: `${i18next.t(
              'viewMode.dollhouse'
            )}<div>(<span>1</span>/5)</div>`,
            intro: i18next.t('tutorial.step1'),
          },
          {
            element: '.dollhouse-tutorial',
            title: `${i18next.t(
              'tutorial.hotspot'
            )}<div>(<span>2</span>/5)</div>`,
            intro: i18next.t('tutorial.step2'),
            position: 'left',
          },
          {
            element: '.birdview-btn',
            title: `${i18next.t(
              'viewMode.birdView'
            )}<div>(<span>3</span>/5)</div>`,
            intro: i18next.t('tutorial.step3'),
          },
          {
            element: '.fpview-button',
            title: `${i18next.t('tutorial.back')}<div>(<span>4</span>/5)</div>`,
            intro: i18next.t('tutorial.step4'),
          },
          {
            element: '.svg-ruler',
            title: `${i18next.t(
              'tutorial.ruler'
            )}<div>(<span>5</span>/5)</div>`,
            intro: i18next.t('tutorial.step5'),
            position: 'left',
          },
        ],
      });
    }
  };

  handleLanguageChange = () => {
    const { styles } = StoreGetters.getCurrentRenderFloorData();
    this.setSteps(styles);
  };

  async componentDidMount() {
    SynchronizeController.setRenderScenes(
      this.leftScene.threeScene,
      this.rightScene.threeScene
    );
    this.loadData(() => {
      SynchronizeController.init(
        this.props.isMultiFloor,
        () => {
          this.props.onReady();
          this.setState({ viewLoadCompleted: true });

          // navigation postMessage bridge
          if (!this.outboundBridgeUnsubscribe) {
            this.outboundBridgeUnsubscribe = navigationBridge.attachOutbound();
          }
          if (!this.inboundBridgeUnsubscribe) {
            this.inboundBridgeUnsubscribe = navigationBridge.attachInbound();
          }
        },
        this.props.cache
      );
    });

    let viewVariable = {
      isDrawingRuler: false,
      isCameraMoving: false,
    };

    store.dispatch(actions.setViewVariable(viewVariable));

    window.addEventListener('resize', this.handleRWD);
    window.addEventListener('keydown', this.onKeyDown, false);
    this.handleRWD();

    // SynchronizeController.changeStyle(1);
    const { queryStringList } = store.getState();
    // console.log(queryStringList);
    if (queryStringList.style == 'true') {
      this.changeView(VIEW.RIGHTFULL);
    }

    if (queryStringList.sceneMode == 'single') {
      this.changeView(VIEW.SINGLE);
    } else if (queryStringList.sceneMode == 'double') {
      this.changeView(VIEW.DOUBLE);
    }

    const { styles } = StoreGetters.getCurrentRenderFloorData();
    this.setSteps(styles);
    i18next.on('languageChanged', this.handleLanguageChange);
  }

  onKeyDown = e => {
    console.log(e.keyCode);
    // switch (e.keyCode) {
    //   case 65: //  a key
    //     this.changeView(VIEW.RIGHTFULL);
    //     break;
    //   case 83: //  S key
    //     this.changeView(VIEW.SINGLE);
    //     break;
    //   case 68: //  D key
    //     this.changeView(VIEW.DOUBLE);
    //     break;
    //   // case
    // }
  };

  componentWillUnmount() {
    i18next.off('languageChanged', this.handleLanguageChange);
    window.removeEventListener('resize', this.handleRWD);
    window.removeEventListener('keydown', this.onKeyDown);

    if (this.outboundBridgeUnsubscribe) {
      this.outboundBridgeUnsubscribe();
    }
    if (this.inboundBridgeUnsubscribe) {
      this.inboundBridgeUnsubscribe();
    }
  }

  handleRWD = () => {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      this.setState({
        RWD: 'Mobile',
      });
    } else {
      this.setState({
        RWD: 'PC',
      });
    }
  };

  changeSecondStyle = index => {
    if (this.state.viewLoadCompleted) {
      this.setState({
        viewLoadCompleted: false,
        styleLoadCompleted: false,
      });
      const { styles } = StoreGetters.getCurrentRenderFloorData();
      if (styles.length === 1) {
        alert('資料只有一個style');
        return;
      }

      const wait = SynchronizeController.changeStyle(index);
      // eslint-disable-next-line
      if (wait != undefined) {
        wait.then(() => {
          this.setState({
            viewLoadCompleted: true,
          });
          setTimeout(() => {
            this.setState({
              styleLoadCompleted: true,
            });
          }, waitTime);
        });
      }
    }
  };

  changeView = view => {
    this.setState({
      view: view,
      styleLoadCompleted: false,
    });

    setTimeout(() => {
      this.setState({
        styleLoadCompleted: true,
      });
    }, waitTime);
  };

  triggerQRCodeBoard() {
    this.setState({
      openQRCodeBoard: !this.state.openQRCodeBoard,
    });
  }

  changeFloor(index) {
    SynchronizeController.changeFloor(index);
    // this.setState({ currentFloorIndex: index });
  }

  toggleMenu() {
    this.setState({
      openTitleMenu: !this.state.openTitleMenu,
    });
  }

  toggleTutorial = () => {
    if (this.state.view === VIEW.DOUBLE) {
      this.changeView(VIEW.SINGLE);
    }
    this.setState(prevState => ({ stepsEnabled: !prevState.stepsEnabled }));
  };

  tutorialStepChange = nextStepIndex => {
    const { viewButton } = store.getState();
    const { goDown, goUp, toOrthographics } = viewButton;
    switch (nextStepIndex) {
      case 1:
        goUp();
        break;
      case 2:
        goDown();
        break;
      case 3:
        toOrthographics();
        break;
      case 4:
        goDown();
        break;
      case 6:
        if (this.state.view === VIEW.SINGLE) {
          this.changeView(VIEW.DOUBLE);
        }
        break;
      default:
        break;
    }
  };

  render() {
    const { data } = StoreGetters.getAllFloorData();
    const {
      building,
      customerLogo: { watermarkUrl },
    } = store.getState();
    const RWD = this.state.RWD === 'PC' ? '' : '-mobile';
    const { stepsEnabled, steps, initialStep } = this.state;

    const { viewLoadCompleted, isNotFirst } = this.state;
    const roomTagsLeft = [];
    const roomTagsRight = [];
    const wallRulerleft = [];
    let isTitleDropdown =
      this.state.openTitleMenu === true ? '-isDropdown' : '';

    if (viewLoadCompleted) {
      if (this.leftScene) {
        const Obj_leftInfo = this.leftScene.threeScene.currentSceneInfo;
        if (this.state.view == VIEW.SINGLE || this.state.view == VIEW.DOUBLE) {
          // room tag
          const roomNameLeft = Object.keys(Obj_leftInfo.rooms);
          roomNameLeft.forEach((id, index) => {
            const group = data.group[index];
            if (group.info.isShowing) {
              roomTagsLeft.push(
                <RoomTag
                  room={Obj_leftInfo.rooms[id]}
                  key={id}
                  hotspot={Obj_leftInfo.hotspots[id][id]}
                  isMain={true}
                  mode={this.state.view}
                  type={this.state.RWD}
                  scene={SynchronizeController.leftScene}
                  isShowing={group.info.isShowing}
                />
              );
            }
          });
        }

        // ruler
        let rulerArrays = Obj_leftInfo.rulerGroup.map(group => group.children);
        const rulerMeshes = [].concat.apply([], rulerArrays);
        rulerMeshes.forEach((mesh, index) => {
          wallRulerleft.push(
            <Ruler
              cameraHeight={this.cameraHeight}
              mesh={mesh}
              key={index}
              mode={this.state.view}
              type={this.state.RWD}
              scene={this.leftScene.threeScene}
              removeCU2={removeCU2}
            />
          );
        });
      }

      if (this.rightScene) {
        if (
          this.state.view == VIEW.RIGHTFULL ||
          this.state.view == VIEW.DOUBLE
        ) {
          // room tag
          const Obj_rightInfo = this.rightScene.threeScene.currentSceneInfo;
          const roomNameRight = Object.keys(Obj_rightInfo.rooms);

          roomNameRight.forEach((id, index) => {
            const group = data.group[index];
            if (group.info.isShowing) {
              roomTagsRight.push(
                <RoomTag
                  room={Obj_rightInfo.rooms[id]}
                  key={id}
                  hotspot={Obj_rightInfo.hotspots[id][id]}
                  isMain={false}
                  mode={this.state.view}
                  type={this.state.RWD}
                  scene={SynchronizeController.rightScene}
                />
              );
            }
          });
        }
      }
    }

    return (
      <div className={'viewerContainer' + RWD}>
        <Steps
          enabled={stepsEnabled}
          steps={steps}
          initialStep={initialStep}
          onBeforeChange={nextStepIndex =>
            this.tutorialStepChange(nextStepIndex)
          }
          onExit={this.toggleTutorial}
          onComplete={() => this.changeView(VIEW.SINGLE)}
          options={{
            nextLabel: i18next.t('tutorial.next'),
            doneLabel: i18next.t('tutorial.done'),
            showBullets: false,
            hidePrev: true,
            showStepNumbers: false,
            buttonClass: 'stepBtn',
            tooltipClass: 'stepClass',
            highlightClass: 'customHighlightClass',
          }}
        />
        <div className="dollhouse-tutorial"></div>
        {this.state.RWD == 'PC' ? (
          <>
            <ThreeScene
              isMain={true}
              mode={this.state.view}
              RWD={this.state.RWD}
              STATE={STATE}
              ref={ref => {
                this.leftScene = ref;
              }}
            />
            <ThreeScene
              isMain={false}
              mode={this.state.view}
              RWD={this.state.RWD}
              STATE={STATE}
              ref={ref => {
                this.rightScene = ref;
              }}
            />
            {
              <div style={{ position: 'absolute', left: '26px', top: '31px' }}>
                <div className="title_name">
                  <span className="title_text">
                    <Trans>{building.floorList[0].name}</Trans>
                  </span>
                </div>

                <SelectionList
                  ref={ref => {
                    this.selectionList = ref;
                  }}
                  parent={this}
                />
              </div>
            }
            {/* <VerifySection /> */}
            {watermarkUrl && (
              <div className="waterprint">
                <img src={watermarkUrl} alt="waterprint" />
              </div>
            )}

            {viewLoadCompleted && wallRulerleft}
            {viewLoadCompleted && roomTagsLeft}
            {viewLoadCompleted && roomTagsRight}

            {/* {this.isMultiStyle && (
              <StyleSelection
                parent={this}
                mode={this.state.view}
                RWD={this.state.RWD}
              />
            )} */}
            {(viewLoadCompleted || isNotFirst) && (
              <ViewChangeMenu
                viewerCameraController={
                  this.leftScene.threeScene.viewerCameraController
                }
                objectManager={ObjectManagers[0]}
                parent={this}
                type={this.state.RWD}
                display={viewLoadCompleted}
              />
            )}
            <ToolBar
              isMultiStyle={this.isMultiStyle}
              mode={this.state.view}
              parent={this}
              RWD={this.state.RWD}
              leftviewerCameraController={
                this.leftScene != null
                  ? this.leftScene.threeScene.viewerCameraController
                  : null
              }
              rightviewerCameraController={
                this.leftScene != null
                  ? this.rightScene.threeScene.viewerCameraController
                  : null
              }
              toggleTutorial={this.toggleTutorial}
            />
            {this.state.openQRCodeBoard === true && (
              <QRCodeBoard parent={this} />
            )}
            {this.state.styleLoadCompleted == false && (
              <div className="loadingAnim">
                <img src={loading} />
              </div>
            )}
          </>
        ) : (
          <>
            <ThreeScene
              isMain={true}
              mode={this.state.view}
              RWD={this.state.RWD}
              ref={ref => {
                this.leftScene = ref;
              }}
            />
            <ThreeScene
              isMain={false}
              mode={this.state.view}
              RWD={this.state.RWD}
              ref={ref => {
                this.rightScene = ref;
              }}
            />
            {
              <div className="title_name_mobile_div">
                <div className={'title_name_mobile' + isTitleDropdown}>
                  <span className={'title_text' + isTitleDropdown}>
                    <Trans>{building.floorList[0].name}</Trans>
                  </span>
                </div>
                <div className="title_dropdown_mobile">
                  {this.state.openTitleMenu && (
                    <div className="title_dropdown">
                      <span className="title_dropdown_text">
                        <Trans></Trans>
                      </span>
                    </div>
                  )}
                </div>
                <button
                  className="title_dropdown_btn"
                  onClick={this.toggleMenu}
                >
                  <img src={titleDropdown} alt="titleDropdown" />
                </button>
              </div>
            }
            <SelectionList
              ref={ref => {
                this.selectionList = ref;
              }}
              parent={this}
            />
            {/* <VerifySection /> */}
            {watermarkUrl && (
              <div className="waterprint">
                <img src={watermarkUrl} alt="waterprint" />
              </div>
            )}

            {viewLoadCompleted && wallRulerleft}
            {viewLoadCompleted && roomTagsLeft}
            {viewLoadCompleted && roomTagsRight}

            {this.state.openQRCodeBoard === true && (
              <QRCodeBoard parent={this} />
            )}
            {this.state.styleLoadCompleted == false && (
              <div className="loadingAnim">
                <img src={loading} />
              </div>
            )}
            <FunctionBarMobile
              parent={this}
              mode={this.state.view}
              RWD={this.state.RWD}
              viewLoadCompleted={viewLoadCompleted}
              isNotFirst={isNotFirst}
              ObjectManagers={ObjectManagers[0]}
              leftScene={this.leftScene}
              isMultiStyle={this.isMultiStyle}
            />
          </>
        )}
      </div>
    );
  }
}
